import {connect} from "react-redux";
import FastTagTollActivityList from "./List";
import {bindActionCreators} from "redux";
import {activityList} from "../../../service/Activity/action";
import {isCheckout, markAttendance, errorLogs} from "../../../service/FasttagToll/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {ratingSave} from "../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails:state.FasttagToll.isCheckout,
    attendance:state.FasttagToll.attendance,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            isCheckout,
            markAttendance,
            documentUploadUrlPublic,
            ratingSave,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FastTagTollActivityList);
